import { render, staticRenderFns } from "./EmpresasLicitacaoTabela.vue?vue&type=template&id=7e4caff4"
import script from "./EmpresasLicitacaoTabela.vue?vue&type=script&lang=js"
export * from "./EmpresasLicitacaoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports